import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_ErrorText, EAA_Add_Btn, EAA_Memo, EAA_Date } from '~/components/EditAndAddItem';
import * as getTime from '~/skills/getTime';

const emptyBody = {
  end_date: '',
  start_date: '',
};

const App = props => {
  const { titleWidth, disabled, checkChange, changeData, data } = props;
  const ary = data.sub1 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub1', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_NativeBoat_sub_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '規劃船期' : ''} bol={isFirst} haveChange={checkChange('eeeee')} />
            <EAA_Date displayBorder disabled={disabled} hint='開始日期' value={getTime.returnDate(ary[i].start_date)} onChange={data => { ary[i].start_date = getTime.getType3Time(data); saveSub(ary); }} marginRight={8} />
            <EAA_Date displayBorder disabled={disabled} hint='結束日期' value={getTime.returnDate(ary[i].end_date)} onChange={data => { ary[i].end_date = getTime.getType3Time(data); saveSub(ary); }} marginRight={8} />
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
